
import { ToasterService } from "@topline/services/toasterService";
import moment from "moment";
import { GridValueEditorService } from "../../common/gridValueEditor/service/gridValueEditorService";

class SkuProductForecastComponentController {
    public parameters: $TSFixMe;
    public marketForecast: $TSFixMe;
    public brand: $TSFixMe;
    public isEditable: boolean;
    public skuPriceService: string;
    public priceLoadService: string;
    public wizardStepIndex: number;
    public showMarketInMilions: boolean = false;
    public showProductInMilions: boolean = false;
    public marketId: $TSFixMe;
    public componentCallbacks: $TSFixMe = {};
    public events: $TSFixMe;
    public selectedTabIndex: $TSFixMe;
    public forecastLength: number;
    public loadPriceTranslationKey: string;
    public skuSplitValueEditorOptions: $TSFixMe;
    public priceInBrandValueEditorOptions: $TSFixMe;
    public brandMkshr: $TSFixMe;
    public loadingPrice: $TSFixMe;
    public marketVal: $TSFixMe;
    public productVal: $TSFixMe;
    public ppgVal: $TSFixMe;

    static $inject = [
        '$rootScope',
        'synchronousEventsBus',
        '$scope',
        '$injector',
        'forecastCacheService',
        GridValueEditorService.componentName,
        ToasterService.componentName
    ];

    constructor(
        private $rootScope: ng.IRootScopeService,
        private synchronousEventsBus: $TSFixMe,
        private $scope: ng.IScope,
        private $injector: $TSFixMe,
        private forecastCacheService: $TSFixMe,
        private gridValueEditorService: GridValueEditorService,
        private toasterService: ToasterService
    ) {
        this.showMarketInMilions = false;
        this.showProductInMilions = false;
        this.marketId = this.forecastCacheService.getForecast().market.id;
        this.componentCallbacks = {};
        this.events = {
            onBrandChange: (newValue: $TSFixMe, oldValue: $TSFixMe) => {
                const brand = newValue;
                if (!brand || !brand.skus) {
                    return;
                }
                this.calculatePrices(brand);
                this.updateMktShrForBrand(brand);
                this.updateSkuMktShr(brand);
            }
        };
    }

    public tabDeselected = (index: $TSFixMe) => {
        this.selectedTabIndex = index;
    };

    $onInit() {
        this.forecastLength = moment(this.parameters.forecastEndDate).diff(this.parameters.forecastStartDate, 'months') + 1;
        this.loadPriceTranslationKey = this.$injector.get(this.priceLoadService).buttonTranslationKey;
        this.gridValueEditorInit();
        
        this.$scope.$watch('$ctrl.brand', this.events.onBrandChange);
        this.$scope.$watch('$ctrl.parameters.forecastType.typeId', (typeId: $TSFixMe) => {
            if (typeId)
                this.marketVal = this.productVal = this.ppgVal = this.parameters.forecastType.typeId == 'value';
        });
        this.$rootScope.$on('wizard:stepChanged', (event: $TSFixMe, args: $TSFixMe) => {
            if (args.index == this.wizardStepIndex && this.brand) {
                this.events.onBrandChange(this.brand, this.brand);
            }
        });
    }

    public showPriceForecastGrid() {
        if (this.brand) {
            // @ts-expect-error ts-migrate(2304) FIXME: Cannot find name 'call'.
            call('priceInBrandEditorShow');
        }
    }

    public showSkuShrGrid() {
        if (this.brand) {
            this.updateSkuMktShr(this.brand);
        }
    }

    public showBrandShrGrid() {
        if (this.brand) {
            this.updateMktShrForBrand(this.brand);
        }
    }

    public skuPriceChanged(oracleIndexes: $TSFixMe) {
        for (const oracleIndex of oracleIndexes) {
            const sku = _.find(this.brand.skus, (s: $TSFixMe) => s.oracleIndex == oracleIndex);
            this.$injector.get(this.skuPriceService).skuPriceChanged(this.parameters, this.brand, sku.forecast);
        }
    }


    private gridValueEditorInit() {
        const dataToGridHeader = this.gridValueEditorService.prepareHeaderData(
            moment.utc(this.parameters.historicalDataEnd).add(-11, 'months').toDate(),
            this.parameters.forecastEndDate
        );

        this.skuSplitValueEditorOptions = {
            gridName: "skuSplitValueEditorOptions",
            header: dataToGridHeader,
            readOnly: true,
            valuesSpecialEnd: '%',
            showFooter: true
        };

        this.priceInBrandValueEditorOptions = {
            gridName: "priceInBrandValueEditorOptions",
            header: dataToGridHeader,
            readOnlyCells: 12,
            propagateData: true,
            showPropagateButton: true,
            valuesDecimalPlaces: 2,
            updateCell: (input: $TSFixMe, idx: $TSFixMe, element: $TSFixMe) => {
                if (this.priceInBrandValueEditorOptions.propagateData) {
                    for (let i = idx - this.priceInBrandValueEditorOptions.readOnlyCells, max = element.values.length; i < max; i++) {
                        element.values[i] = parseFloat(input);
                    }
                } else {
                    element.values[idx - this.priceInBrandValueEditorOptions.readOnlyCells] = parseFloat(input);
                }
                this.skuPriceChanged([element.oracleIndex]);
            }
        };
    }

    public loadPrice = () => {
        this.loadingPrice = this.$injector.get(this.priceLoadService).getPrices(this.brand, this.parameters)
            .then((data: $TSFixMe) => {
                if (_.isEmpty(data)) {
                    this.toasterService.warning('FORECAST.PRODUCT.NO_PRICE_IN_PRICE_LIST');
                    return;
                }
                for (const sku of this.brand.skus) {
                    var priceArray = data[sku.oracleIndex];
                    if (angular.isArray(priceArray)) {
                        for (let i = 0; i < sku.forecast.price.length && i < priceArray.length; i++) {
                            sku.forecast.price[i] = priceArray[i];
                        }
                        var gridData = _.find(this.priceInBrandValueEditorOptions.gridData, (x: $TSFixMe) => x.oracleIndex == sku.oracleIndex);
                        if (gridData) {
                            gridData.values = sku.forecast.price;
                        }
                    }
                }
                this.priceInBrandValueEditorOptions.gridData = this.priceInBrandValueEditorOptions.gridData.slice();
                this.skuPriceChanged(this.brand.skus.map((s: $TSFixMe) => s.oracleIndex));
            });
    };

    private calculatePrices(brand: $TSFixMe) {
        let dataToPriceGridValueEditor = [];
        for (let sku of brand.skus) {
            let historicalPrice = sku.forecast.historicalPrice.slice(-12);
            dataToPriceGridValueEditor.push({
                header: sku.name,
                oracleIndex: sku.oracleIndex,
                historicalValues: historicalPrice,
                values: sku.forecast.price,
            });
        }
        this.priceInBrandValueEditorOptions.gridData = _.sortBy(dataToPriceGridValueEditor, 'header');
    }

    private updateMktShrForBrand(brand: $TSFixMe) {
        if (brand.forecast.historicalMksh) {
            this.brandMkshr = brand.forecast.historicalMksh.concat(
                _.map(brand.forecast.mkshr, (item: $TSFixMe) => item / 100.0)
            );
        }
    }

    private updateSkuMktShr(brand: $TSFixMe) {
        let dataToGridValueEditor: $TSFixMe[] = [];
        angular.forEach(brand.skus, (sku: $TSFixMe) => {
            if (sku.forecast.historicalBrandShr) {
                let historicalValues = sku.forecast.historicalBrandShr ? sku.forecast.historicalBrandShr.slice(-12) : _.times(12, _.constant(null));
                dataToGridValueEditor.push({
                    header: sku.name,
                    values: _.map(historicalValues.concat(sku.forecast.brandShr), (x: $TSFixMe) => x * 100),
                });
            }
        });
        let sumValue = this.prepareFooterData(dataToGridValueEditor, 12);
        this.skuSplitValueEditorOptions.gridData = _.sortBy(dataToGridValueEditor, 'header');
        this.skuSplitValueEditorOptions.footerData = new Array(12).fill(null).concat(
            sumValue.reduce((r: $TSFixMe, a: $TSFixMe) => r.map((b: $TSFixMe, i: $TSFixMe) => a[i] + b))
        );
    }

    private prepareFooterData(arr: $TSFixMe, skipIndex: $TSFixMe) {
        let result: $TSFixMe[] = [];
        angular.forEach(arr, (x: $TSFixMe) => {
            result.push(x.values.slice(skipIndex));
        });
        return result;
    }
}

export class SkuProductForecastComponent implements ng.IComponentOptions {
    static componentName = 'skuProductForecast';
    bindings = {
        parameters: '<',
        marketForecast: '<',
        brand: '<',
        isEditable: '<',
        skuPriceService: '@',
        priceLoadService: '@',
        wizardStepIndex: '=',
        showMarketInMilions: '<',
        showProductInMilions: '<'
    };
    controller = SkuProductForecastComponentController;
    template = require('./skuProductForecastComponent.html');
}

angular.module('topline.modules').component(SkuProductForecastComponent.componentName, new SkuProductForecastComponent());